import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Modal } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useVto } from '../../../context/VtoProvider.js';
import { loadVirtualMirror } from '../../utils/load-vm.js';
import { initializationParams } from '../../config/initOptions.js';

const VirtualMirrorModal = ({ variants  })=>{
    const { isVtoActive , setVtoActive , config: config1  } = useVto();
    const { apiKey , environment , script  } = config1;
    const { locale , region  } = useIntl();
    const [vmapp1, setVmapp] = React__default.useState();
    const onModalClose = ()=>{
        var ref;
        if (vmapp1 && ((ref = vmapp1.config) === null || ref === void 0 ? void 0 : ref.onClose)) {
            vmapp1.config.onClose();
            setVtoActive(false);
        }
    };
    React__default.useEffect(()=>{
        Promise.all([
            loadVirtualMirror(script)
        ]).then(([vmmv])=>{
            try {
                const DEFAULT_INIT_PARAMS = initializationParams(apiKey, environment, locale, region);
                const config = swcHelpers.objectSpread({}, DEFAULT_INIT_PARAMS, variants, {
                    onClose: ()=>{
                        vmapp.unmount();
                        setVtoActive(false);
                    }
                });
                const vmapp = new vmmv.VMWidgetApp(config);
                vmapp.init();
                setVmapp(vmapp);
            } catch (err) {
                setVtoActive(false);
                console.error(err);
            }
        }).catch((err)=>{
            console.error(err);
        });
    }, [
        variants,
        locale,
        isVtoActive,
        setVtoActive,
        apiKey,
        environment,
        script
    ]);
    if (!variants) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "virtual-mirror",
        "data-t": "virtual-mirror"
    }, isVtoActive && /*#__PURE__*/ React__default.createElement(Modal, {
        activeTrap: false,
        "data-t": "virtual-mirror-modal",
        isOpen: true,
        className: "virtual-mirror__modal",
        onModalClose: ()=>onModalClose()
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "virtual-mirror__target"
    })));
};

export { VirtualMirrorModal };
//# sourceMappingURL=VirtualMirrorModal.js.map
